export default __webpack_public_path__ + "static/media/veiyon_tech.83973b90.svg";